// React
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

// Containers Injections
import { SellersInjection } from '../../containers/sellersInjection';

// View
import { SellersPage } from './view';

export const Sellers = () => {
  const [activeStatus, setActiveStatus] = useState('true');

  const { getSellers, sellers, deleteSellers, success } = SellersInjection();

  const history = useHistory();

  const makeDataToFilter = () => {
    return sellers.map((seller) => {
      return {
        id: seller.id,
        name: seller.name.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
        cpf: seller.cpf,
      };
    });
  };

  const handleDelete = (id) => {
    deleteSellers(id);
  };

  const handleEdit = (values) => {
    const { id } = values;

    history.push(`/corretores/edit/${id}`);
  };

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Nome</span>,
      id: 'type',
      sortable: false,
      width: '30%',
      selector: (cell) => {
        return (
          <React.Fragment>
            <div className="d-flex align-items-center fw-medium ">
              <Link
                className="currency_name"
                to={`/corretores/edit/${cell.id}`}
              >
                {cell.name}
              </Link>
            </div>
          </React.Fragment>
        );
      },
    },
  ];

  useEffect(() => {
    getSellers(activeStatus);
  }, [success, activeStatus]);

  return (
    <SellersPage
      history={history}
      columns={columns}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
      setActiveStatus={setActiveStatus}
      makeDataToFilter={makeDataToFilter}
    />
  );
};
